module.exports = __webpack_public_path__ + "img/dept-10.f3315aa0.svg";